import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './BigText.css';

const BigText = ({
  className = '',
  text,
  smallText = '',
  color = undefined,
  alignment = 'bottom',
  ...otherProps
}) => {

  const classes = classNames(
    'ng-ui-widgets',
    'ng-ui-big-text',
    `align-${alignment}`,
    className,
  );

  const style = Object.assign({}, color ? { color } : { });

  return (
    <div
      {...otherProps}
      className={classes}
      style={style}
    >
      {String(text)}
      {smallText !== '' ? <small>{smallText}</small> : null}
    </div>
  );
};

BigText.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  alignment: PropTypes.oneOf([
    'top',
    'bottom',
  ]),
  color: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  smallText: PropTypes.string,
};

export default BigText;